import { INTERCOM_APP_ID } from '../env';
import { FLEET_PLANS } from '../constants/plans';
import { invertObjectKeysAndValues } from 'utils';
import { AuthUser } from 'services/resources';
import { isAvigoHost, isWeeveHost } from './branding.utils';

function getIntercom() {
  const { Intercom } = window;

  if (isWeeveHost() || isAvigoHost()) {
    Intercom('shutdown');
  } else if (typeof Intercom === 'function') {
    return Intercom;
  }

  return (...args) => args;
}

export function boot() {
  getIntercom()('boot', {
    app_id: INTERCOM_APP_ID,
  });
}

export function update(options = null) {
  if (options) {
    getIntercom()('update', options);
  } else {
    getIntercom()('update');
  }
}

export function showNewMessage(message: string) {
  getIntercom()('showNewMessage', message);
}

export function authenticate(user: AuthUser) {
  const plans = invertObjectKeysAndValues(FLEET_PLANS);

  getIntercom()('update', {
    user_hash: user.intercomHash,
    name: `${user.firstName} ${user.lastName}`,
    email: user.email,
    companies: [
      {
        company_id: user.profile.dealership.id,
        name: user.profile.dealership.name,
        plan: plans[user.profile.dealership.settings.planId],
      },
    ],
    attributes: {
      user_role: user.profile.role,
    },
    language_override: user.profile.language,
  });
}

export function shutdown() {
  getIntercom()('shutdown');
}

export function trackEvent(eventName: string, metadata: object) {
  getIntercom()('trackEvent', eventName, metadata);
}
